module.exports = __webpack_public_path__ + "img/IMG_1096.93ed31c1.jpg";